import React, { Component } from 'react'
import { Row, Col, Modal, Button, Select, Menu, Table, Radio, Pagination } from 'antd'
import Card from '../../components/Card'
import Loading from '../../components/Loading'
import PpeAdd from './PpeAdd'
import { api, app, config } from "../../app"
import utils from "../../utils"

const MenuItem = Menu.Item

function getPpeId(ppe_id, ppeTypeList) {
    for (let i = 0; i < ppeTypeList.length; i++) {
        if (ppe_id === ppeTypeList[i].id) {
            return [ppe_id]
        } else if (ppeTypeList[i].subclass) {
            for (let i2 = 0; i2 < ppeTypeList[i].subclass.length; i2++) {
                if (ppe_id === ppeTypeList[i].subclass[i2].id) {
                    return [ppeTypeList[i].id, ppe_id]
                } else if (ppeTypeList[i].subclass[i2].subclass) {
                    for (let i3 = 0; i3 < ppeTypeList[i].subclass[i2].subclass.length; i3++) {
                        if (ppe_id === ppeTypeList[i].subclass[i2].subclass[i3].id) {
                            return [ppeTypeList[i].id, ppeTypeList[i].subclass[i2].id, ppe_id]
                        }
                    }
                }
            }
        }
    }
    return undefined
}

class SkillAdd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ppeList: [],
            userPpe: [],
            ppeTypeList: [],
            organizationList: [],
            data_loading: false,
            add_visible: false,
            fileList: [],
            scheduleList: [],
            ppeClassList: [],
            ppeInfo: {},
            show: 1,
            page: 1,
            total: 0,
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.handlePeeTypes()
        await this.PpeSource()
        await this.PpeTypeSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 技能分类
     * @constructor
     */
    PpeTypeSource = async () => {
        let { flag, data, msg } = await app.post(api.PpeClass)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ ppeTypeList: data })
    }

    /**
     * 技能分类点击
     **/
    handlePpeClassChange = async ({ key }) => {
        if (key === '0') {
            await this.setData({ ppeList: this.state.userPpe })
        } else {
            await this.setData({ data_loading: true })
            let { flag, data, msg } = await app.post(api.PpeClassList, { id: key, indexno: app.getData('indexno') })
            const state = { data_loading: false }
            if (flag === 1) {
                state.ppeList = data
            } else {
                app.alert(msg, "error")
            }
            await this.setData(state)
        }
    }

    /**
     * 发证机构
     * @constructor
     */
    PpeOrganizationSource = async (class_id) => {
        await this.setData({ org_loading: true, organizationList: [] })
        let params = {
            class_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.OListing, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ organizationList: data, org_loading: false })
    }


    /**
     * 技能数据
     * @constructor
     */
    PpeSource = async () => {
        await this.setData({ data_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.MyPpe, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ ppeList: data, userPpe: data, data_loading: false })
    }

    handleCloseModal = async () => {
        await this.setData({ add_visible: false, ppeInfo: '', is_edit: '' })
    }

    handleOpenModal = async (info) => {
        let state = { add_visible: true, is_edit: null }
        if (info) {
            info.ppe_id = info.ppe_id ? getPpeId(info.ppe_id, this.state.ppeTypeList) : undefined
            state.ppeInfo = info
            state.is_edit = info.id
        }
        this.setState(state)
    }

    normFile = (e) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    // handleAddJG = () => {
    //     let loading = false
    //     let organization_name = ''
    //     let change = (e) => {
    //         let { value } = e.target
    //         organization_name = value
    //     }
    //     Modal.confirm({
    //         title: '添加认证机构',
    //         content: (
    //             <div>
    //                 <Input style={{ margin: '20px 0' }} placeholder="请输入认证机构名" onChange={change} maxLength={100}/>
    //                 <div style={{ color: "red" }}>慎重添加，只记录最高级认证机构。如中国红十字。省级或者更基层级别认证机构不予审批。</div>
    //             </div>
    //         ),
    //         style: { top: '30%' },
    //         width: 500,
    //         keyboard: false,
    //         maskClosable: false,
    //         destroyOnClose: true,
    //         okText: '提交',
    //         cancelText: '取消',
    //         confirmLoading: loading,
    //         zIndex: 99,
    //         onOk: async () => {
    //             if (!organization_name) {
    //                 app.alert('请输入认证机构名！', 'warn')
    //                 return Promise.reject()
    //             }
    //             loading = true
    //             let params = {
    //                 organization_name,
    //                 indexno: app.getData('indexno'),
    //                 account: app.getData('account'),
    //             }
    //             let { flag, msg } = await app.post(api.OAdd, params)
    //             if (flag === 1) {
    //                 app.alert('提交成功，等待审核~', 'success')
    //             } else {
    //                 app.alert(msg, 'error')
    //             }
    //             return Promise.resolve()
    //         },
    //     })
    // }

    /**
     * 打开技能对话框
     * @param ppe
     * @constructor
     */
    OpenPpeModal = async (ppe) => {
        if (ppe.ppe_status === '1') {
            await this.setData({ ppe_visible: true, ppe_loading: true })
            let params = {
                ppe_id: ppe.ppeid,
                object_indexno: app.getData('indexno'),
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, data, msg } = await app.post(api.PpeDetails, params)
            let state = { ppe_loading: false }
            if (flag === 1) {
                data.ppe_status = '1'
                state.ppeInfo = data
            } else {
                app.alert(msg, "error")
            }
            await app.sleep()
            await this.setData(state)
        } else {
            this.setData({ ppe_visible: true, ppeInfo: ppe })
        }
    }

    /**
     * 关闭技能对话框
     * @constructor
     */
    ClosePpeModal = () => {
        this.setState({ ppe_visible: false, ppe_loading: false, ppeInfo: {} })
    }

    handleSwitch = async (show) => {
        if (show === 1) {
            await this.setData({ show: 2 })
            await this.handleScheduleData()
        } else if (show === 2) {
            this.setData({ show: 1 })
        }
    }

    /**
     * 技能分类
     * @returns {{xAxis: {data: Array}, series: *[]}}
     */
    async handlePeeTypes() {
        let { flag, data, msg } = await app.post(api.HomeClassList, data)
        if (flag === 1) {
            await this.setData({ ppeClassList: data })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 进度数据
     */
    handleScheduleData = async (page = 1) => {
        await this.setData({ page, schedule_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.PpeReviewProgress, params)
        let state = { schedule_loading: false }
        if (flag === 1) {
            state.scheduleList = utils.addArrayKey(data)
        } else {
            app.alert(msg, "error")
        }
        if (page === this.state.page) {
            state.total = parseInt(total || 0)
            this.setState(state)
        }
    }

    /**
     * 编辑成功
     */
    handleEditSuccess = async () => {
        await this.setData({ add_visible: false })
        await this.handleSwitch(1)
    }

    render() {
        let { show, page, total, is_edit, ppeClassList, scheduleList, schedule_loading, ppe_visible, ppe_loading, ppeTypeList, ppeInfo, data_loading, ppeList, submit_loading, add_visible } = this.state
        let columns = [
            {
                title: '序号',
                dataIndex: 'xh',
                key: 'xh',
                width: '5%',
                render: (xh, row, index) => index + 1
            },
            {
                title: '技能系列',
                dataIndex: 'classname',
                key: 'classname',
                width: '20%'
            },
            {
                title: '已提交的技能',
                dataIndex: 'ppename',
                key: 'ppename',
                width: '25%',
                render(ppename, { organization_name }) {
                    return (<span>
                        <div>{ppename}</div>
                        <div>{organization_name}</div>
                    </span>)
                }
            },
            {
                title: '审核状态',
                dataIndex: 'status',
                key: 'status',
                width: '15%',
                render(status) {
                    let txt = "-"
                    switch (status) {
                        case "0":
                            txt = "审核中"
                            break
                        case "1":
                            txt = "已通过"
                            break
                        case "2":
                            txt = "不通过"
                            break
                    }
                    return txt
                }
            },
            {
                title: '提交时间',
                dataIndex: 'uptime',
                key: 'uptime',
                width: '15%'
            },
            {
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '20%',
                render: (id, record) => {
                    return <span>
                        <Button type="primary" style={{ marginRight: 20 }}
                            onClick={() => this.OpenPpeModal({ ppe_status: '1', ppeid: id })}>技能详情</Button>
                        <Button type="primary" onClick={() => this.handleOpenModal(Object.assign({}, record))}
                            disabled={record.is_operate !== 1}>编辑</Button>
                    </span>
                }
            },
        ]
        return (
            <div className="member-page skill-page">
                <div className="mp-content">
                    <Card width="100%" style={{ padding: 20, height: "calc(100% - 68px)" }} className="obtain-skill"
                        title={
                            <Row>
                                <Col span={12}>{show === 1 ? "已获得技能" : "技能审核进度"}</Col>
                                <Col span={12} style={{ textAlign: 'right' }}>
                                    <Button onClick={() => this.handleSwitch(show)} type="primary"
                                        hidden={show === 1}>已获得的技能</Button>
                                    <Button onClick={() => this.handleSwitch(show)} hidden={show === 2}
                                        type="primary">技能审核进度</Button>
                                    <Button onClick={() => this.handleOpenModal()} type="primary"
                                        style={{ marginLeft: 20 }}>添加技能</Button>
                                </Col>
                            </Row>
                        }>
                        <div hidden={show !== 1}>
                            <div className="ppe-top">
                                <Menu mode="horizontal" className="mp-menu" defaultSelectedKeys={['0']}
                                    onClick={this.handlePpeClassChange}>
                                    <MenuItem key="0">已获得</MenuItem>
                                    {
                                        ppeClassList.map(cla => {
                                            return (
                                                <MenuItem key={cla.id}>{cla.names}</MenuItem>
                                            )
                                        })
                                    }

                                </Menu>
                            </div>
                            <div className="ppe-bottom">
                                {
                                    data_loading ? (<Loading />) :
                                        (ppeList.length > 0 ?
                                            ppeList.map((p, i) => {
                                                return (
                                                    <div className="ppe" key={i}
                                                        onClick={() => this.OpenPpeModal(p)}
                                                        title={p.names}>
                                                        <img className="ppe-img" src={config.imgUrl + p.icon}
                                                            alt="" />
                                                        <div className="ppe-name">{p.names}</div>
                                                        {
                                                            p.ppe_status !== '1' ? (
                                                                <div className="lock">
                                                                    <i className="iconfont icon-suo" />
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                )
                                            }) : (<p className="no-data">您还没有技能~</p>)
                                        )}
                            </div>
                        </div>
                        <div style={{ height: "100%" }} hidden={show !== 2}>
                            <Table columns={columns}
                                locale={app.tbLocale(schedule_loading)}
                                dataSource={scheduleList}
                                loading={schedule_loading}
                                scroll={{ y: 'calc(100% - 103px)' }}
                                style={{ height: '100%', margin: 0 }}
                                className="ranks_table"
                                pagination={false}
                                size="small"
                                footer={scheduleList.length === 0 ? null : () => {
                                    return (
                                        <div style={{ textAlign: 'right' }}>
                                            <Pagination total={total} size="small" pageSize={20} current={page}
                                                showTotal={(total) => `总数量：${total}`}
                                                onChange={this.handleScheduleData} />
                                        </div>
                                    )
                                }}
                            />
                        </div>
                    </Card>
                </div>
                <Modal
                    visible={add_visible}
                    title={<h3 style={{ textAlign: "center" }}>{is_edit ? "编辑" : "添加"}技能</h3>}
                    footer={null}
                    width="60%"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleCloseModal}
                    bodyStyle={{ minHeight: 'calc(80vh - 100px)' }}
                    centered={true}
                    zIndex={1010}
                >
                    <PpeAdd is_edit={is_edit} info={ppeInfo || {}} ppeTypeList={ppeTypeList} success={this.handleEditSuccess} />
                </Modal>
                <Modal
                    visible={ppe_visible}
                    title="技能详情"
                    footer={null}
                    width={800}
                    style={{ top: 20 }}
                    centered={true}
                    destroyOnClose={true}
                    onCancel={this.ClosePpeModal}
                    zIndex="1010"
                    className="add-skill-ppe-modal"
                >
                    {
                        ppe_loading ? <Loading /> :
                            ppeInfo.ppe_status === '1' ? (
                                <div className="ppe-items">
                                    <Row className="ppe-item">
                                        <Col span={12}>
                                            <div className="ppe-lable">技能图标</div>
                                            <div className="ppe-text">
                                                <img src={config.imgUrl + ppeInfo.icon} alt="" width="60" height="60"
                                                    title={ppeInfo.names} />
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="ppe-lable">队员名称</div>
                                            <div className="ppe-text">{ppeInfo.vname}</div>
                                        </Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={12}>
                                            <div className="ppe-lable">技能名称</div>
                                            <div className="ppe-text">{ppeInfo.names}</div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="ppe-lable">发证机构</div>
                                            <div className="ppe-text">{ppeInfo.organization_name}</div>
                                        </Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={12}>
                                            <div className="ppe-lable">技能系列</div>
                                            <div className="ppe-text">{ppeInfo.classname}</div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="ppe-lable">提交时间</div>
                                            <div className="ppe-text">{ppeInfo.uptime}</div>
                                        </Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={12}>
                                            <div className="ppe-lable">获证日期</div>
                                            <div className="ppe-text">{ppeInfo.datetime}</div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="ppe-lable">到期日期</div>
                                            <div className="ppe-text">{ppeInfo.is_long === '1' ? ppeInfo.expire_time : '长期 / 无有效期'}</div>
                                        </Col>
                                    </Row>
                                    <div className="ppe-item">
                                        <div className="ppe-lable">证书详情</div>
                                        <div className="ppe-imgs">
                                            {
                                                (ppeInfo.images || []).map((ppe, i) => {
                                                    return (
                                                        <div key={i} className="ppe-img">
                                                            <a href={config.imgUrl + ppe} target="_blank" key={i}>
                                                                <img src={config.imgUrl + ppe} alt="" /></a>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <Row className="ppe-item">
                                        {/* <Col span={12} className="ppe-lable">队伍管理员审核状态 </Col> */}
                                        <Col span={12} className="ppe-lable">管理员审核状态</Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        {/* <Col span={12}>
                                            <div className="ppe-lable">队管审核</div>
                                            <div className="ppe-text">{ppeInfo.team_header_name || '-'}</div>
                                        </Col> */}
                                        <Col span={12}>
                                            <div className="ppe-lable">管理员审核</div>
                                            <div className="ppe-text">{ppeInfo.admin_name || '-'}</div>
                                        </Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        {/* <Col span={12}>
                                            <div className="ppe-lable">审核状态</div>
                                            <div
                                                className="ppe-text">{ppeInfo.team_header_audit === "1" ? "已通过" : (ppeInfo.team_header_audit === "2" ? "不通过" : "未审核")}</div>
                                        </Col> */}
                                        <Col span={12}>
                                            <div className="ppe-lable">审核状态</div>
                                            <div
                                                className="ppe-text">{ppeInfo.admin_audit === "1" ? "已通过" : (ppeInfo.admin_audit === "2" ? "不通过" : "未审核")}</div>
                                        </Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={12} hidden={ppeInfo.team_header_audit !== '2'}>
                                            <div className="ppe-lable">不通过原因</div>
                                            <div className="ppe-text">{ppeInfo.detail || '-'}</div>
                                        </Col>
                                        <Col span={12} hidden={ppeInfo.admin_audit !== '2'}>
                                            <div className="ppe-lable">不通过原因</div>
                                            <div className="ppe-text">{ppeInfo.detail || '-'}</div>
                                        </Col>
                                    </Row>
                                </div>
                            ) : (
                                <div>
                                    <Row className="ppe-item">
                                        <Col span={4} className="ppe-lable">技能图标：</Col>
                                        <Col span={17} offset={1} className="ppe-text">
                                            <img src={config.imgUrl + ppeInfo.icon} alt="" className="ppe-img"
                                                width="60" height="60" title={ppeInfo.names} /></Col>
                                    </Row>
                                    <Row className="ppe-item">
                                        <Col span={4} className="ppe-lable">备注：</Col>
                                        <Col span={17} offset={1} className="ppe-text2">{ppeInfo.remarks || '无'}</Col>
                                    </Row>
                                </div>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

export default SkillAdd



// WEBPACK FOOTER //
// ./src/routes/playerInfo/SkillAdd.jsx